import Vue from "vue";
import { ValidationObserver, ValidationProvider, extend, setInteractionMode } from 'vee-validate';
import { required, email, confirmed, min} from 'vee-validate/dist/rules';

Vue.component('validation-observer', ValidationObserver);
Vue.component('validation-provider', ValidationProvider);

// Validation
// TO DO: TRANSLATE MESSAGES

extend('required', {
    ...required,
    message: 'This field is required'
});

extend('email', {
    ...email,
    message: 'Email address is not correct'
});

extend('confirmed', {
    ...confirmed,
    message: 'Passwords must match'
});

extend('min', {
    ...min,
    message: '{_field_} must have at least {length} characters'
});

extend('date-format', {
    validate(value) {
        const dateRegex = '([12]\d{3}-(0[1-9]|1[0-2])-(0[1-9]|[12]\d|3[01]))';
        return dateRegex.test(value);
    },
    message: 'Date must be in a yyyy-mm-dd format. I.e. 1990-08-15'
});

setInteractionMode('eager');
